
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/DualAxes/index.md?watch=parent';
    export const demoIndex = {
  ids: ["dualaxes-demo-common","dualaxes-demo-markdown","dualaxes-demo-multiple"],
  getter: () => import(/* webpackChunkName: "meta__DualAxes" */'/home/runner/work/GPT-Vis/GPT-Vis/src/DualAxes/index.md?type=demo')
};